// src/state/pageState.js
import { atom } from 'recoil';

export const pageState = atom({
  key: 'pageState', // Assicurati che la chiave sia unica per tutto lo stato dell'applicazione
  default: -1, // Imposta il valore di default dello state, ad esempio lo step iniziale del tuo processo
});
